import { reminderConfigResponseSchema } from "../../schemas/finance/reminders";
import { fetchApi } from "../client/internal";

export const reminders = {
	getConfig: (clubId: string) => fetchApi(`/${clubId}/reminders`, reminderConfigResponseSchema),
	updateConfig: (clubId: string, data: unknown) =>
		fetchApi(`/${clubId}/reminders`, reminderConfigResponseSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
};
